import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { ChevronDown, ChevronUp } from 'react-feather';
import { useTranslations } from 'use-intl';
import { toNamespaceKey, toTranslationKey } from '@/utils/translations';

interface RegistrySectionProps {
	title: string;
	isOpen: boolean;
	onToggle: () => void;
	children: React.ReactNode;
	translationsKey?: string;
}

export const RegistrySection: React.FC<RegistrySectionProps> = ({
	title,
	isOpen,
	onToggle,
	children,
	translationsKey = 'RegistryDetails'
}) => {
	const t = useTranslations(toNamespaceKey(translationsKey));

	return (
		<div className="bg-white p-5 rounded-lg shadow overflow-auto custom-scrollbar">
			<div
				className="flex flex-row items-center justify-between cursor-pointer"
				onClick={onToggle}
				role="button"
				aria-expanded={isOpen}
				tabIndex={0}
				onKeyPress={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						onToggle();
					}
				}}
			>
				<Typography size="md" weight="semibold">
					{t(toTranslationKey(title))}
				</Typography>
				{isOpen ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
			</div>
			{isOpen && (
				<div className="mt-4" role="region" aria-labelledby={`${title}-section`}>
					{children}
				</div>
			)}

			<style>{`
				.custom-scrollbar::-webkit-scrollbar {
					width: 8px;
					height: 8px;
				}

				.custom-scrollbar::-webkit-scrollbar-track {
					background: #f1f1f1;
					border-radius: 4px;
				}

				.custom-scrollbar::-webkit-scrollbar-thumb {
					background: #888;
					border-radius: 4px;
				}

				.custom-scrollbar::-webkit-scrollbar-thumb:hover {
					background: #555;
				}

				/* For Firefox */
				.custom-scrollbar {
					scrollbar-width: thin;
					scrollbar-color: #888 #f1f1f1;
				}
			`}</style>
		</div>
	);
};

export default RegistrySection;
